import React from "react";
import { AccessibilityButton } from '@skillz/accessibility';
import classes from './Buttons.module.css'

const ArrowsBtn = ({ onClick, dropClass, color, left, right, small, medium, large, boxShadow, oneArrow, accessibilityDescription }) => {

    return (
        <AccessibilityButton accessibilityDescription={accessibilityDescription || 'Arrow'} className={`${classes.Btn} ${classes.ArrowsBtn} ${small && classes.Small} ${medium && classes.Medium} ${large && classes.Large} ${boxShadow && classes.BoxShadow} ${dropClass} ${oneArrow && classes.OneArrow}`} onClick={onClick} >
            <svg style={{ transform: left ? "rotate(180deg)" : 0 }} xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <ellipse cx="12.008" cy="12.0001" rx="12.0001" ry="12.008" transform="rotate(-90 12.008 12.0001)" />
                <path className={classes.ArrowSvg} d="M6.47266 17.8077L12.4766 11.8521L6.47266 6.1947" stroke={color} strokeWidth="2" strokeLinecap="round" />
                <path className={classes.GrayArrowSvg} d="M12.3359 17.8077L18.3399 11.8521L12.3359 6.1947" stroke={color} strokeWidth="2" strokeLinecap="round" />
            </svg>
        </AccessibilityButton>
    )
}

export default ArrowsBtn;